module.exports = __webpack_public_path__ + "static/media/ofirmi2.4058af1a.bmp";